export function initSlider($) {
	$('.slider.slider-standard').each(function(n, el) {
		$('.owl-carousel', el).owlCarousel({
			items: 1,
			loop: true,
			nav: true,
			dots: true,
			autoplay: true,
			autoplayTimeout: 5000,
			smartSpeed: 1000,

			// animateIn: 'fadeIn',
			// animateOut: 'fadeOut',
		});
	});

	$('.slider.gallery-slider').each(function(n, el) {
		var carousel = $('.owl-carousel', el).owlCarousel({
			items: 1,
			loop: true,
			nav: false,
			dots: true,
			autoplay: false,
			autoplayTimeout: 5000,
			dots: false,
			smartSpeed: 1000,

			// animateIn: 'fadeIn',
			// animateOut: 'fadeOut',
		});

		$('.slide-nav-link', el).on('click', function(e) {
			e.preventDefault();
			carousel.trigger('to.owl.carousel', $(this).index());
		});
	});

	$('.slider.slider-offset-text').each(function(n, el) {
		$('.owl-carousel', el).owlCarousel({
			items: 1,
			loop: true,
			nav: true,
			dots: true,
			autoplay: true,
			autoplayTimeout: 5000,
			smartSpeed: 1000,

			animateIn: 'fadeIn',
			animateOut: 'fadeOut',
		});
	});
}